'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiDivideOutline = function TiDivideOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 14.2c-2.8 0-5-2.3-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5z m0-6.7c-0.9 0-1.7 0.7-1.7 1.7s0.8 1.6 1.7 1.6 1.7-0.7 1.7-1.6-0.8-1.7-1.7-1.7z m0 28.3c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.3 5 5-2.2 5-5 5z m0-6.6c-0.9 0-1.7 0.7-1.7 1.6s0.8 1.7 1.7 1.7 1.7-0.7 1.7-1.7-0.8-1.6-1.7-1.6z m10-4.2h-20c-2.8 0-5-2.2-5-5s2.2-5 5-5h20c2.8 0 5 2.2 5 5s-2.2 5-5 5z m-20-6.7c-0.9 0-1.7 0.8-1.7 1.7s0.8 1.7 1.7 1.7h20c0.9 0 1.7-0.8 1.7-1.7s-0.8-1.7-1.7-1.7h-20z' })
        )
    );
};

exports.default = TiDivideOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/divide-outline.js
// module id = 3057
// module chunks = 0